export default __webpack_public_path__ + "static/media/imp-img.9e14cec8.png";